import {Plugin} from './plugins';

export class Work {
  slug: string;
  url: string;
  name: string;
  externalUrl: string;
  dateCompleted: Date;
  slogan: string;
  mainImage: string;
  summary: string;
  challenge: string;
  outcome: string;
  tags: string[];
  content: number;
  plugins: Plugin[];

  constructor() {
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/models/work.ts